<script setup>
import { ref, watch } from 'vue';
import FordButton from '@/components/FordButton.vue';
import { useToast } from 'vue-toastification';
import CInput from './CInput.vue';
import EventSection from './EventSection.vue';
import statusCodes from './statusCodes';

const props = defineProps({
  event: Object,
  email: String,
  statuses: Object,
});

const toast = useToast();

// show error validation toast
watch(
  () => props.statuses.signInStatus,
  (obj) => {
    if (obj === statusCodes.failed) {
      toast.error(
        'We were unable to validate your code. Please check that you entered it correctly, or resubmit your email to generate a new code',
        { timeout: 10000 },
      );
    }
  },
  { deep: true },
);

const emit = defineEmits(['sign-in', 'send-again']);

const code = ref('');

const signIn = () => emit('sign-in', code.value);
const sendAgain = () => emit('send-again', props.email);
</script>
<template>
  <div class="tablet:text-center">
    <form @submit.prevent="signIn">
      <h1 class="
        text-[1.125rem] tablet:text-[2.125rem]
        font-FordAntennaMed
        mb-[1.875rem]
        max-w-[53rem]
        mx-auto
      ">
        Welcome to the Ford Pro™ Events appointment scheduler. Let's get you logged in!
      </h1>
      <p
        class="
          text-[.875rem] tablet:text-[1rem]
          text-ford-gray-darker
          mb-[1.875rem]
        ">
        Enter the validation code sent to {{ email }}<br/>
        Didn't receive your code?
        <a
          tabindex="0"
          @keydown.enter="sendAgain"
          @click.prevent="sendAgain"
          aria-label="Re-submit email for validation">
          <span class="underline text-ford-blue-dark">Send again.</span>
        </a>
      </p>
      <c-input
        class="max-w-[45.5rem] mx-auto"
        aria-label="Validation code"
        type="text"
        v-model="code"
        placeholder="Validation code"
        required />
      <ford-button
        v-if="statuses.signInStatus === statusCodes.loading"
        class="
          mb-[3rem]
        "
        :prevent-default="false"
        disabled>Signing in...</ford-button>
      <ford-button
        v-else
        class="
          mb-[3rem]
        "
        :prevent-default="false"
        >Sign-In</ford-button>
    </form>
    <hr class="
      mx-auto
      max-w-[50rem]
      mb-[2.5rem] hidden tablet:block
    " />
    <event-section :event="event" />
  </div>
</template>
